import * as angular from 'angular';
import { Decimal } from 'decimal.js';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpEightFractionValidator
     * @memberof app
     *
     * @restrict A
     *
     * @description
     * Validates that a number has no more than 8 decimal places.
     * Controlled via the useEightFractionalDigitsUPABidCheck feature flag.
     */
    angular
        .module('app')
        .directive('pkpEightFractionValidator', pkpEightFractionValidator);

    function pkpEightFractionValidator() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) return;

                ngModelCtrl.$validators.eightDecimals = function (
                    modelValue,
                    viewValue
                ) {
                    var val = viewValue;
                    if (val === undefined || val === null || val === '') {
                        val = modelValue;
                    }

                    if (val === undefined || val === null || val === '')
                        return true;

                    try {
                        var dec = new Decimal(val);
                        return dec.equals(new Decimal(dec.toFixed(8)));
                    } catch (e) {
                        return false;
                    }
                };

                attrs.$observe('pkpEightFractionValidator', function () {
                    ngModelCtrl.$validate();
                });
            }
        };
    }
})();
